import { useCallback, useState } from 'react';

import clsx from 'clsx';
import { createEditor } from 'slate';
import type { RenderElementProps, RenderLeafProps } from 'slate-react';
import { Editable, Slate, withReact } from 'slate-react';

import { useEditorValue } from '@app/hooks/rich-text/use-editor-value';
import { useRefreshKey } from '@app/hooks/rich-text/use-refresh-key';

import { Element, Leaf } from '../slate-components';
import style from './lite-rich-text-viewer.module.scss';
import type { LiteRichTextViewerProps } from './types';

export const LiteRichTextViewer = ({
  nodes,
  className,
  elementClassNames = {},
}: LiteRichTextViewerProps) => {
  const [editor] = useState(() => withReact(createEditor()));
  const { editorValue } = useEditorValue(nodes, undefined);
  const refreshKey = useRefreshKey(nodes);

  const renderElement = useCallback(
    (elementProps: RenderElementProps) => <Element {...elementProps} />,
    [],
  );
  const renderLeaf = useCallback((leafProps: RenderLeafProps) => <Leaf {...leafProps} />, []);

  const { container: containerClassName, editable: editableClassName } = elementClassNames;

  return (
    <div className={clsx(style.LiteRichTextViewer, className)}>
      <Slate
        editor={editor}
        initialValue={editorValue}
        key={refreshKey}
      >
        <div className={clsx(style.LiteRichTextViewerEditableContainer, containerClassName)}>
          <Editable
            readOnly
            spellCheck={false}
            renderElement={renderElement}
            renderLeaf={renderLeaf}
            style={{
              minHeight: 'unset',
            }}
            className={clsx(style.LiteRichTextViewerEditable, editableClassName)}
          />
        </div>
      </Slate>
    </div>
  );
};
